import { sRGBEncoding, Vector3 } from "three";
import { WebGLRenderer } from "three";
import { PerspectiveCamera } from "three";
import { MainScene } from "./scene/mainScene";
import { Loading } from "../components/modals/Loading";
import { LoadingManager } from "three";
import gsap from "gsap";
import { OrbitControls } from "../utils/OrbitControls";
import { GUI } from "dat.gui";
export class App {
  constructor(container) {
    this.loading = new Loading();
    this.loadingManager = new LoadingManager();
    this.container = container;
    this.camera = new PerspectiveCamera(
      60,
      this.container.clientWidth / this.container.clientHeight,
      4,
      780
    );
    // this.camera = new OrthographicCamera( this.container.clientWidth / - 2, this.container.clientWidth / 2, this.container.clientHeight / 2, this.container.clientHeight / - 2, 1, 1000 );
    // this.camerap = new PerspectiveCamera(
    //   60,
    //   this.container.clientWidth / this.container.clientHeight,
    //   0.1,
    //   600
    // );
    // this.camerap.position.set(25, 10, 6);
    this.camera.position.set(337.534, 1105.96, 189.881);
    this.camera.rotation.set(-0.205, 0.013, 0.003);
    // this.camera.rotation.set((-30 * Math.PI) / 180, 0, 0);
    // this.camera.rotation.set(0,0,0)
    this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.outputEncoding = sRGBEncoding;
    this.renderer.physicallyCorrectLights = true;
    this.renderer.shadowMap.enabled = true;

    this.container.appendChild(this.renderer.domElement);
    this.control = new OrbitControls(this.camera, this.container);
    this.control.target.set(331, 1000, -320);
    this.control.rotateSpeed = 0.4;
    this.control.enableDamping = true;
    this.control.maxDistance = 750;
    this.control.minDistance = 4;
    this.control.dampingFactor = 0.08;
    this.control.maxPan = new Vector3(1000, 1000, 1000);
    this.control.minPan = new Vector3(-1000, -1000, -1000);
    this.control.enabled = false;
    this.control.maxPolarAngle = Math.PI / 2.3;

    this.mainScene = new MainScene(
      this.container,
      this.renderer,
      this.camera,
      this.loadingManager,
      this.control
    );

    // this.helpercamera = new CameraHelper(this.camera)
    // this.mainScene.add(this.helpercamera)
    // this.stats = new Stats();
    // document.body.appendChild( this.stats.dom );

    this.loadingProyect();
    this.render();
    this.onResized();
  }

  loadingProyect() {
    this.loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
      console.log(
        "Started loading file: " +
          url +
          ".\nLoaded " +
          itemsLoaded +
          " of " +
          itemsTotal +
          " files."
      );
    };
    this.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
      const percentage = (itemsLoaded / itemsTotal) * 100;
      document.getElementById("loadingBar").style.width = `${Math.round(
        percentage
      )}%`;
      // console.log( 'Loading file: ' + url + '.\n %' +percentage );
    };
    this.loadingManager.onLoad = () => {
      gsap.to("#loading", {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          this.loading.hiddenModalLoading();
          this.onResized();
          console.log("Loading complete!");
        },
      });
    };
  }

  onResized() {
    this.renderer.setSize(
      this.container.clientWidth,
      this.container.clientHeight
    );
    this.camera.aspect =
      this.container.clientWidth / this.container.clientHeight;
    this.camera.updateProjectionMatrix();
  }

  render() {
    // this.stats.update();
    const leftb = Math.floor(window.innerWidth * 0);
    const bottomb = Math.floor(window.innerHeight * 0);
    const widthb = Math.floor(window.innerWidth * 1);
    const heightb = Math.floor(window.innerHeight * 1.0);
    this.renderer.setViewport(leftb, bottomb, widthb, heightb);
    this.renderer.setScissor(leftb, bottomb, widthb, heightb);
    this.renderer.setSize(
      this.container.clientWidth,
      this.container.clientHeight
    );
    this.renderer.setScissorTest(true);
    this.renderer.render(this.mainScene, this.camera);
    //
    const left = Math.floor(window.innerWidth * 0.7);
    const bottom = Math.floor(window.innerHeight * 0.0);
    const width = Math.floor(window.innerWidth * 0.3);
    const height = Math.floor(window.innerHeight * 0.25);
    this.renderer.setViewport(left, bottom, width, height);
    this.renderer.setScissor(left, bottom, width, height);
    this.renderer.setScissorTest(true);
    this.camera.updateProjectionMatrix();
    // this.renderer.render( this.mainScene, this.camera );
    //
    //
    this.control.update();
    this.mainScene.renderAnimations();
    this.renderer.setAnimationLoop(() => this.render());
  }
}
